// codecs / m.Types that considered as atmos
// "audio/ac4"
// "audio/eac3-joc"

export const atmosCodecsSubstrings = ['ec-3', 'joc', 'ac4']
